import React from 'react';

function FaceMeh(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 2C6.47732 2 2 6.47732 2 12C2 17.5227 6.47732 22 12 22C17.5227 22 22 17.5227 22 12C22 6.47732 17.5227 2 12 2ZM12 3.25C16.8323 3.25 20.75 7.16768 20.75 12C20.75 16.8323 16.8323 20.75 12 20.75C7.16768 20.75 3.25 16.8323 3.25 12C3.25 7.16768 7.16768 3.25 12 3.25ZM8.98432 8.56881L8.875 8.5625L8.76568 8.56881C8.29949 8.62297 7.9375 9.0193 7.9375 9.5C7.9375 10.0177 8.35732 10.4375 8.875 10.4375C9.39268 10.4375 9.8125 10.0177 9.8125 9.5C9.8125 9.0193 9.45051 8.62297 8.98432 8.56881ZM15.125 8.5625L15.2343 8.56881C15.7005 8.62297 16.0625 9.0193 16.0625 9.5C16.0625 10.0177 15.6427 10.4375 15.125 10.4375C14.6073 10.4375 14.1875 10.0177 14.1875 9.5C14.1875 9.0193 14.5495 8.62297 15.0157 8.56881L15.125 8.5625ZM16.375 15.125C16.375 14.7798 16.0952 14.5 15.75 14.5H8.25L8.15764 14.5068C7.85626 14.5514 7.625 14.8112 7.625 15.125C7.625 15.4702 7.90482 15.75 8.25 15.75H15.75L15.8424 15.7432C16.1437 15.6986 16.375 15.4388 16.375 15.125Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default FaceMeh;
